import React from 'react';
import './Sidebar.css';

type SidebarProps = {
  isHide?: boolean
  isPinned?: boolean
  title?: string | JSX.Element
  width?: number
  closedSidebarWidth?: number
  containerStyles?: React.CSSProperties
  onClickPin: (isPinned: boolean) => void
  onClickHide: (isHide: boolean) => void
} & React.PropsWithChildren;

function SidebarDefault({
  isHide = false,
  isPinned = false,
  title = '',
  width = 300,
  closedSidebarWidth = 40,
  containerStyles = {},
  children,
  onClickPin,
  onClickHide,
}: SidebarProps) {
  const sidebarRef = React.useRef<HTMLDivElement | null>(null);

  const onHideClick = () => {
    onClickHide(!isHide);
  };

  const onPinClick = () => {
    onClickPin(!isPinned);
  };

  /**
   * В Эффекте проверяется куда тыкнул пользователь
   * и если такой элемент не содержится в sidebar'e, то он закроется
   */
  React.useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (!isPinned && sidebarRef.current && !sidebarRef.current.contains(e.target as Node)) {
        onClickHide(true);
      }
    }

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [isPinned, onClickHide]);

  return (
    <div
      ref={sidebarRef}
      style={{
        width: isHide ? closedSidebarWidth : width,
      }}
      aria-hidden={isHide}
      className="sidebar-wrapper"
    >
      <div
        className="sidebar-content"
        style={{
          width,
          transform: `${isHide ? `translate(-${width - closedSidebarWidth}px)` : 'none'}`,
        }}
      >
        <div className="sidebar-content-header">
          {typeof title === 'string' ? <h3>{title}</h3> : title}
          <div className="sidebar-controll">
            <button
              className="sidebar-button"
              type="button"
              onClick={onPinClick}
            >
              <PinIcon isPinned={isPinned} />
            </button>
            <button
              className="sidebar-button"
              type="button"
              onClick={onHideClick}
            >
              {isHide ? '☰' : 'X'}
            </button>
          </div>
        </div>
        <div
          className="sidebar-main-content-container"
          style={{
            ...containerStyles,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

const Sidebar = React.memo(SidebarDefault);
Sidebar.displayName = 'Sidebar';

export { Sidebar };

function PinIcon({ isPinned = false }: { isPinned: boolean }) {
  return (
    <svg data-icon="lock" width="18" height="100%" viewBox="0 0 16 16" role="img" fill={isPinned ? '#c42d2d' : '#425A70'}>
      <path d="M13.96 7H12V3.95C12 1.77 10.21 0 8 0S4 1.77 4 3.95V7H1.96c-.55 0-.96.35-.96.9v6.91c0 .54.41 1.19.96 1.19h12c.55 0 1.04-.65 1.04-1.19V7.9c0-.55-.49-.9-1.04-.9zM6 7V3.95c0-1.09.9-1.97 2-1.97s2 .88 2 1.97V7H6z" fillRule="evenodd" />
    </svg>
  );
}
